/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type Likes_viewer$ref = any;
export type LikesRefetchQueryVariables = {
    readonly createdAfter: string;
    readonly eventsLimit: number;
    readonly fetchNewEvents: boolean;
    readonly fetchNotifications: boolean;
    readonly notificationItemsLimit: number;
    readonly userId: string;
};
export type LikesRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": Likes_viewer$ref;
    } | null;
};
export type LikesRefetchQuery = {
    readonly response: LikesRefetchQueryResponse;
    readonly variables: LikesRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "createdAfter",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "eventsLimit",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchNewEvents",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchNotifications",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "notificationItemsLimit",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Variable",
        "name": "createdAfter",
        "variableName": "createdAfter"
    } as any), v2 = ({
        "kind": "Variable",
        "name": "eventsLimit",
        "variableName": "eventsLimit"
    } as any), v3 = ({
        "kind": "Variable",
        "name": "notificationItemsLimit",
        "variableName": "notificationItemsLimit"
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v5 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "LikesRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Likes_viewer",
                            "args": [
                                (v1 /*: any*/),
                                (v2 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "fetchNewEvents",
                                    "variableName": "fetchNewEvents"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "fetchNotifications",
                                    "variableName": "fetchNotifications"
                                },
                                (v3 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "LikesRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchNewEvents",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "favoriteNotifications",
                                    "storageKey": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "FavoriteNotifications",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "hasNewEvents",
                                            "args": [
                                                (v1 /*: any*/),
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchNotifications",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "favoriteNotificationsTiles",
                                    "name": "favoriteNotifications",
                                    "storageKey": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "FavoriteNotifications",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": "tiles",
                                            "name": "notificationsList",
                                            "storageKey": null,
                                            "args": [
                                                (v1 /*: any*/),
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "Variable",
                                                    "name": "notificationsLimit",
                                                    "variableName": "eventsLimit"
                                                }
                                            ],
                                            "concreteType": "FavoriteNotification",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "type",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "eventType",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "createdDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "lastViewedDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "followingType",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "page",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "totalResults",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "items",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": true,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "pdpURL",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "firstPhotoWebPath",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "size",
                                                                    "value": "thumb"
                                                                }
                                                            ],
                                                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                                                        },
                                                        (v4 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "name",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/)
                                            ]
                                        },
                                        (v4 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "LikesRefetchQuery",
            "id": "ferrum/234.0.0-2019-09-20T21:19:24.316Z/LikesRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'ab2f3c4d7c41daccff0f4fa979704e09';
export default node;
